import React from 'react'
import useTimer from '@/shared/hooks/useTimer'

export function FormatDateWithConditions({ utcDate }: any): React.ReactNode {
  const istDate = new Date(utcDate)

  const time = useTimer(utcDate)?.timer
  const today = new Date()
  const tomorrow = new Date(today)
  tomorrow.setDate(tomorrow.getDate() + 1)

  const Timer = ({ timer }: { timer: any }) => {
    if (timer.hours !== 0 && timer.min !== 0) {
      return (
        <div className="md:text-base text-xxs">
          {timer.hours}H : {timer.min}M : {timer.sec}S
        </div>
      )
    } else {
      return null
    }
  }

  // Calculate difference in days
  const diffTime = istDate.getTime() - today.getTime()
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
  const diffHours = diffTime / (1000 * 60 * 60)

  // Format time
  const hours = istDate.getHours()
  const formattedTime = `${hours > 12 ? hours - 12 : hours}:${String(istDate.getMinutes()).padStart(2, '0')} ${hours >= 12 ? 'PM' : 'AM'}`
  const months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ]
  if (diffDays > 2) {
    return (
      <div>
        <div className="text-t-secondary text-xs md:text-base">
          {String(istDate.getDate()).padStart(2, '0')} {months[istDate.getMonth()]}{' '}
          {istDate.getFullYear()}
        </div>
        <div className="text-ScheduledBG md:text-lg">{formattedTime}</div>
      </div>
    )
  }

  if (diffHours > 0 && diffHours < 4 && time) {
    return <Timer timer={time} />
  }

  // Check if date is today or tomorrow
  if (
    istDate.getDate() === today.getDate() &&
    istDate.getMonth() === today.getMonth() &&
    istDate.getFullYear() === today.getFullYear()
  ) {
    return (
      <div>
        <div className="text-t-secondary text-sm md:text-base">Today</div>
        <div className="text-ScheduledBG md:text-lg">{formattedTime}</div>
      </div>
    )
  } else if (
    istDate.getDate() === tomorrow.getDate() &&
    istDate.getMonth() === tomorrow.getMonth() &&
    istDate.getFullYear() === tomorrow.getFullYear()
  ) {
    return (
      <div>
        <div className="text-t-secondary text-sm md:text-base">Tomorrow</div>
        <div className="text-ScheduledBG md:text-lg">{formattedTime}</div>
      </div>
    )
  }

  return (
    <div>
      <div className="text-t-secondary text-xs md:text-base">
        {String(istDate.getDate()).padStart(2, '0')} {months[istDate.getMonth()]}{' '}
        {istDate.getFullYear()}
      </div>
      <div className="text-ScheduledBG md:text-lg">{formattedTime}</div>
    </div>
  )
}
